import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import deleteaction from "../../assets/images/deleteaction.svg";
import Plusicon from "../../assets/images/Plusicon.svg";
import bankdollor from "../../assets/images/bankdollor.svg";
import downaccordion from "../../assets/images/downaccordion.svg";
import billingsplans from "../../assets/images/billingsplans.svg";
import {
    PaymentMethod_CreatePayment,
    PaymentMethodList,
    PaymentMethodSetPrimary,
} from "../../services/ReduxTookit/Slice/InvoiceRedux";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import DeleteModal from "../../Modals/DeleteModal";
import { API_URL } from "../../services/APIRoute";
import ConfirmationModel from "../../Modals/ConfirmationModel";
import { getCardBrandImage } from "../../services/CommonServices";

const PaymentMethodManagementModel = ({
    IsPaymentSuccess,
    OnlinePaymentDetails,
}) => {
    const dispatch = useDispatch();

    let ProfileInfo = useSelector((state) => state?.userinfo?.UserInfo);
    const [PrimaryLoader, setPrimaryLoader] = useState(false);
    const [PaymentMethodIDForPrimary, setPaymentMethodIDForPrimary] = useState(0);
    const [PrimaryConfirmation, setPrimaryConfirmation] = useState(false);
    const [loading, setLoading] = useState(true);
    const [PaymentMethodData, setPaymentMethodData] = useState(null);

    const [DeletePayload, setDeletePayload] = useState({
        id: "",
        status: "",
    });
    const [modalShow, setModalShow] = useState(false);
    const [PaymentMethodAddLoader, setPaymentMethodAddLoader] = useState(false);
    const fnAddNewPaymentMethod = async () => {
        setPaymentMethodAddLoader(true);
        try {
            const body = {
                amount: 1,
                invoiceno: ProfileInfo.subscriberid + "00001",
                returnurl:
                    window.location.origin + "/management-listing?from=paymentmethod&session_id={CHECKOUT_SESSION_ID}",
                associationid: ProfileInfo.subscriberid,
                associationtype: "Subscriber Add Payment Method",
            };
            const rest = await dispatch(PaymentMethod_CreatePayment(body));

            if (
                rest &&
                rest.payload &&
                rest.payload.isValidate &&
                rest.payload.data
            ) {
                if (rest.payload.data.status_code === 1 && rest.payload.data.data) {
                    window.location = rest.payload.data.data;
                } else {
                    toast.error(rest.payload.data.message);
                }
            }
            setPaymentMethodAddLoader(false);
        } catch (error) {
            setPaymentMethodAddLoader(false);
        }
    };

    const getPaymentMethodList = async () => {
        setLoading(true);
        const body = {};
        dispatch(PaymentMethodList(body))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    setPaymentMethodData(response?.payload?.data?.data);
                }
                if (!response?.payload?.isValidate) {
                    setPaymentMethodData(null);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getPaymentMethodList();
    }, [OnlinePaymentDetails, IsPaymentSuccess]);

    const fnUpdatePrimaryPaymentMethod = () => {
        if (PaymentMethodIDForPrimary && PaymentMethodIDForPrimary > 0) {
            setPrimaryLoader(true);
            dispatch(
                PaymentMethodSetPrimary({
                    id: PaymentMethodIDForPrimary,
                })
            ).then((response) => {
                setPrimaryLoader(false);
                if (response?.payload?.isValidate) {
                    getPaymentMethodList(response);
                    setPrimaryConfirmation(false);
                    setPaymentMethodIDForPrimary(0);
                }
            });
        }
    };

    return (
        <div className="setting-payment-method">
            <Row>
                {loading ? (
                    <Loader type={LoaderType.PaymentMethodCard} count={2} />
                ) : (
                    <>
                        {PaymentMethodData && PaymentMethodData?.length > 0 && (
                            <>
                                {PaymentMethodData?.map((item) => {
                                    let DisplayNo = item.methodnumber;
                                    if (item.methodnumber) {
                                        if (item.methodnumber.length < 16) {
                                            for (let i = item.methodnumber.length; i < 16; i++) {
                                                DisplayNo = "X" + DisplayNo;
                                            }
                                        }
                                    } else {
                                        DisplayNo = "XXXXXXXXXXXXXXXX";
                                    }
                                    DisplayNo =
                                        "XXXX-XXXX-XXXX-" +
                                        DisplayNo.substr(DisplayNo.length - 4, DisplayNo.length);
                                    return (
                                        <Col xl={6}>
                                            <div className="main-payment-method">
                                                <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                                                    <div className="payment-method-detail d-block">
                                                        <div className="payment-method-detail-img mb-2">
                                                            {/* {item.brand?.toUpperCase()} */}

                                                            {item?.display_brand &&
                                                                getCardBrandImage(item?.display_brand)}
                                                        </div>
                                                        <div className="payment-method-detail-data d-flex justify-content-between align-items-end">
                                                            <div className="payment-method-detail-data-block">
                                                                <div className="visa-title card-paymeant ">
                                                                    <h4>{item.methodtype?.toUpperCase()}</h4>
                                                                    {item.isprimary ? (
                                                                        <span className="cursor-pointer bg-success text-white">
                                                                            <b>Primary</b>
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className="cursor-pointer"
                                                                            onClick={() => {
                                                                                setPrimaryConfirmation(true);
                                                                                setPaymentMethodIDForPrimary(
                                                                                    item?.paymentmethodid
                                                                                );
                                                                            }}
                                                                        >
                                                                            <b>Set Primary</b>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <p>
                                                                    {item.display_brand
                                                                        ?.replaceAll(/_/g, " ")
                                                                        ?.toUpperCase()}{" "}
                                                                    {item.category?.toUpperCase()}{" "}
                                                                    {item.methodtype?.toUpperCase()}
                                                                </p>
                                                                <div>
                                                                    <img
                                                                        style={{ width: "14px", height: "14px" }}
                                                                        src={billingsplans}
                                                                        alt="billingsplans"
                                                                    />
                                                                    <span className="ms-1">{DisplayNo}</span>
                                                                </div>
                                                            </div>
                                                            {item.isprimary ? (
                                                                <></>
                                                            ) : (
                                                                <div
                                                                    className="payment-method-detail-data-block-delete cursor-pointer"
                                                                    onClick={() => {
                                                                        setModalShow(true);
                                                                        setDeletePayload({
                                                                            id: item?.paymentmethodid,
                                                                        });
                                                                    }}
                                                                >
                                                                    <img src={deleteaction} alt="deleteaction" />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </>
                        )}

                        {PaymentMethodAddLoader ? (
                            <Loader type={LoaderType.PaymentMethodCard} count={1} />
                        ) : (
                            <Col xl={6}>
                                <div
                                    className="main-payment-method cursor-pointer"
                                    onClick={(e) => fnAddNewPaymentMethod()}
                                >
                                    <div className=" backuppaymeant h- auto">
                                        <div className="backuppaymeant-title d-flex align-items-center gap-1">
                                            <span>
                                                <img src={Plusicon} alt="Plusicon" />
                                            </span>
                                            <h4>Add Backup Payment Method</h4>
                                        </div>
                                        <p>
                                            Add a payment method to simplify billing and maintain
                                            uninterrupted access to services.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </>
                )}
            </Row>
            {modalShow && (
                <DeleteModal
                    payload={DeletePayload}
                    method="DELETE"
                    url={API_URL?.PAYMENTMETHOD?.DELETE}
                    show={modalShow}
                    bindlist={getPaymentMethodList}
                    onHide={(e) => setModalShow(false)}
                />
            )}

            {PrimaryConfirmation &&
                PaymentMethodIDForPrimary &&
                PaymentMethodIDForPrimary > 0 && (
                    <ConfirmationModel
                        Loader={PrimaryLoader}
                        onHide={(e) => setPrimaryConfirmation(false)}
                        functionCall={fnUpdatePrimaryPaymentMethod}
                        show={PrimaryConfirmation}
                        headertext="Are you sure you want to set as primary?"
                        messagetext="Please confirm if you wish to proceed with set as primary."
                        yesbuttontext="Yes, Sure"
                    />
                )}
        </div>
    );
};

export default PaymentMethodManagementModel;
